import React from "react";
import { useState, useEffect, useCallback, useMemo } from "react";
import Counter from "../cart/Counter";
import CustomCurrencyFormat from "../utils/CurrencyFormat";
import { IMAGEURL } from "../../config/config";
import dele from "../../assets/images/delete.png";
import { getproductTitle } from "../utils/LanguageField";

function Cartlist(props) {  
  const itemId = props._id;

  const updateCart = (count) => {
    props.updateItem(
      count,
      itemId,
      props[getproductTitle("product_name", "product")],
      props.product_id._id
    );
  };

  return (
    <div className="cartlistitem" key={props._id}>
      <figure className="">
        <img
          src={IMAGEURL + props.product_id.image}
          alt={props.product_name}
        />
      </figure>
      <div className="mobtwo2">
        <p className="itemcart">
          {props[getproductTitle("product_name", "product")]}
        </p>
        <Counter
          qty={props.quantity}
          id={props._id}
          name={props[getproductTitle("product_name", "product")]}
          updateCart={updateCart}
          data-item-id={props._id}
          unit = {props.product_id.unit}
        />
        <div className="price">
          <CustomCurrencyFormat amount={props.price} />
        </div>
      </div>
      <img
        className="cartitemclose"
        onClick={props.deleteItem}
        data-item-id={props._id}
        data-item-name={props.product_name}
        data-product-id={props.product_id._id}
        src={dele}
        alt="cartclose"
      />
    </div>
  );
}

export default Cartlist;
